import { render, staticRenderFns } from "./Pedido.vue?vue&type=template&id=446fe689"
import script from "./Pedido.vue?vue&type=script&lang=js"
export * from "./Pedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports